import PageTemplate from "../components/common/PageTemplate";
import ProductListCategory from "../screen/purchase/product/ProductListCategory";

const ProductCategoryListPage = () => {
  return (
    <>
      <PageTemplate mainComponent={<ProductListCategory />} noFooter={true} />
    </>
  );
};

export default ProductCategoryListPage;
